<!--顾客流失 区总页面-->
<template>
    <div class="storageassets-module">
        <van-pull-refresh v-model="refreshing" success-text="刷新成功" @refresh="onRefresh">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div v-show="checkedStore.id == -1">
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/region-icon.png" alt="">
                        <div class="Blacks font34 bold">区域分布</div>
                    </div>
                </div>
                <div class="select-box flex flex-y-center flex-between">
                    <div class="select-item  flex-start flex-y-center ml-20" @click="selectRegionTimePopup">
                        <div class="select-tit">{{ regionDateTxt }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                    <div class="rate-box font28">
                        客户流失率：<span class="font28 Blacks bold">{{ regionData.lossRate }}({{ regionData.lostTotal }}/{{ regionData.total }})</span>
                    </div>
                </div>
                <div class="total-amount flex-start flex-y-center" @click="openRegionSelectPopup">
                    <div class="txt">{{ regionType.name }} </div>
                    <van-icon name="play" class="select-arrow" />
                </div>
                <div class="unit">单位：人</div>
                <div>
                    <div ref="regionchart" id="regionchart"></div>
                </div>
            </div>
            <div class="cut-line" v-if="checkedStore.id == -1"></div>
            <div>
                <div class="title-box flex-between flex-y-center">
                    <div class="flex-start flex-y-center">
                        <img class="icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/store-icon.png" alt="">
                        <div class="Blacks font34 bold">门店分布</div>
                    </div>
                    <div class="total-amount flex-end">
                        <div class="txt">{{ storeData.deadline }}</div>
                    </div>
                </div>
                <div class="select-box flex flex-y-center flex-between">
                    <div class="select-item  flex-start flex-y-center ml-20" @click="selectStoreTimePopup">
                        <div class="select-tit">{{ storeDateTxt }}</div>
                        <van-icon name="play" class="select-arrow" />
                    </div>
                    <div class="rate-box font28">
                        客户流失率：<span class="font28 Blacks bold">{{ storeData.lossRate }}({{ storeData.lostTotal }}/{{ regionData.total }})</span>
                    </div>
                </div>
                <div class="total-amount flex-start flex-y-center" @click="openStoreSelectPopup">
                    <div class="txt">{{ storeType.name }} </div>
                    <van-icon name="play" class="select-arrow" />
                </div>
                <div class="unit">单位：人</div>
                <div>
                    <div ref="storechart" id="storechart"></div>
                </div>
            </div>
            <div class="cut-line"></div>
            <div class="empty-box">
                <div class="flex-col flex-y-center">
                    <img class="empty-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/storageAssets/empty.png" alt="">
                    <div class="empty-txt">客户详细数据请切换至单门店查看</div>
                </div>
            </div>
        </van-pull-refresh>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
        <van-popup v-model="showRegionTimePopup" round position="bottom" closeable class="popup">
            <date-picker v-model="regionDateType" @submit="handleRegionDate" :pickerType="pickerType"></date-picker>
        </van-popup>
        <van-popup v-model="showStoreTimePopup" round position="bottom" closeable class="popup">
            <date-picker v-model="storeDateType" @submit="handleStoreDate" :pickerType="pickerType"></date-picker>
        </van-popup>
        <!-- 数据筛选 -->
        <van-popup v-model="showRegionSelectPopup" round position="bottom" closeable class="popup">
            <picker title="选择类型" v-model="regionType" :list="typeList" @change="onRegionSelectChange"></picker>
        </van-popup>
        <van-popup v-model="showStoreSelectPopup" round position="bottom" closeable class="popup">
            <picker title="选择类型" v-model="storeType" :list="typeList" @change="onStoreSelectChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { timestampToYestoday } from '@/utils/validate';
    import DatePicker, { getDateText, getFormatTime, PICKER_TYPE } from '@/components/DatePicker';
    import { getCookie } from '@/utils'
    import { mapState } from 'vuex'
    import Picker from '@/components/Picker';
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

    export default {
        inject: ['reload'],
        name: "customerChurnRegionPage",
        components: {
            Picker, DatePicker
        },
        computed: {
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
            regionDateTxt() {
                return getDateText(this.regionDateType, this.regionBeginMonth, this.regionEndMonth, this.pickerType)
            },
            storeDateTxt() {
                return getDateText(this.storeDateType, this.storeBeginMonth, this.storeEndMonth, this.pickerType)
            }
        },
        data() {
            return {
                refreshing: false,
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                showRegionSelectPopup: false,
                showStoreSelectPopup: false,
                pickerType: PICKER_TYPE.MONTH,// 日期类型
                regionDateType: '2', // 日期
                storeDateType: '2', // 日期
                regionBeginMonth: '', // 开始日期
                regionEndMonth: '', // 结束日期
                storeBeginMonth: '', // 开始日期
                storeEndMonth: '', // 结束日期
                updateTime: timestampToYestoday(),   //更新时间
                showRegionTimePopup: false,//选择时间弹窗
                showStoreTimePopup: false,//选择时间弹窗

                typeList: [
                    {
                        id: 1,
                        name: '流失总人数'
                    },
                    {
                        id: 2,
                        name: 'VVIP流失人数'
                    },
                    {
                        id: 3,
                        name: 'V3流失人数'
                    },
                    {
                        id: 4,
                        name: '优质客流失人数'
                    },
                    {
                        id: 5,
                        name: '高潜力流失人数'
                    },
                    {
                        id: 6,
                        name: '基础客流失人数'
                    },
                ],
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
                regionData: {},  // 区域数据
                regionType: {   //  区域筛选
                    id: 1,
                    name: '流失总人数'
                },
                storeData: {},  // 门店数据
                storeType: {    //  门店筛选
                    id: 1,
                    name: '流失总人数'
                },
                regionChart: null,
                storechart: null,
                changeId: ''

            };
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            // 获取当前登陆人所记录的区域门店信息
            getUserLogin().then((res) => {
                if (this.regionPostId.includes(this.postId)) {
                    this.checkedRegion.name = res.data.region?.storeName // 当前区域
                    this.checkedRegion.id = res.data.region?.id
                    if (res.data.store) {
                        this.checkedStore.name = res.data.store.storeName //当前门店
                        this.checkedStore.id = res.data.store.id
                        // 门店列表
                        let params = {
                            id: this.checkedRegion.id
                        }
                        getRegionStoreList(params).then((res) => {
                            this.regionStoreList = res.data
                        })
                    }
                    // 区域列表
                    getRegionStoreList().then((res) => {
                        this.regionList = res.data
                    })
                    this.onLoad();
                }
            })
        },
        methods: {
            //资产饼图加载
            onLoad() {
                this.initRegionChart()
                this.initStoreChart()
            },
            //柱状图-区域
            async initRegionChart() {
                const _this = this
                this.getRegionData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    var yAxisData = this.regionData.regionY;
                    // var yAxisData = ['上海运营四区'];
                    this.regionChart = this.$echarts.init(this.$refs.regionchart);
                    let options = {
                        grid: {
                            top: "7%",
                            left: "3%",
                            bottom: "12%",
                            right: "11%",
                            containLabel: true,
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            formatter: "{b} ({c})",
                        },
                        xAxis: [
                            {
                                gridIndex: 0,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    color: '#66757F'
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#D9D9D9'
                                    }
                                },
                            },
                        ],
                        yAxis: [
                            {
                                gridIndex: 0,
                                interval: 0,
                                data: yAxisData,
                                // splitNumber: 5,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#66757F",
                                        fontSize: 12
                                    },
                                    formatter: function (yAxisData) {
                                        var strs = yAxisData.split(''); //字符串数组
                                        var str = ''
                                        for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                            str += s;
                                            if (!(i % 12)) str += '\n'; //按需要求余
                                        }
                                        return str
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#D9D9D9'
                                    }
                                },

                            },
                        ],
                        series: [
                            {
                                name: "",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "45%",
                                itemStyle: {
                                    barBorderRadius: [2, 2, 2, 2],
                                    color: '#2068F9',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#35434C",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.regionData.regionX,
                            },
                        ],
                    };

                    this.regionChart.setOption(options);
                    // 点击获取该区域id下所有门店的数据
                    this.regionChart.on('click', params => { // 柱形图点击事件
                        let data = {
                            id: params.data.id,
                            storeId: 0
                        }
                        saveRegionStore(data)
                        this.reload()
                    })
                });

            },
            //柱状图-门店
            async initStoreChart() {
                const _this = this
                this.getStoreData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    var yAxisData = this.storeData.regionY;
                    this.storeChart = this.$echarts.init(this.$refs.storechart);
                    let options = {
                        grid: {
                            top: "7%",
                            left: "3%",
                            bottom: "30",
                            right: "10%",
                            containLabel: true,
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            formatter: "{b} ({c})",
                        },
                        xAxis: [
                            {
                                gridIndex: 0,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    color: '#A0ACB5'
                                },
                                splitLine: {
                                    show: true,
                                    lineStyle: {
                                        type: 'dashed'
                                    }
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#D9D9D9'
                                    }
                                },
                            },
                        ],
                        yAxis: [
                            {
                                gridIndex: 0,
                                interval: 0,
                                data: yAxisData,
                                // splitNumber: 5,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#A0ACB5",
                                        fontSize: 12
                                    },
                                    formatter: function (yAxisData) {
                                        var strs = yAxisData.split(''); //字符串数组
                                        var str = ''
                                        for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                            str += s;
                                            if (!(i % 12)) str += '\n'; //按需要求余
                                        }
                                        return str
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: '#D9D9D9'
                                    }
                                },

                            },
                        ],
                        series: [
                            {
                                name: "",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "45%",
                                itemStyle: {
                                    barBorderRadius: [2, 2, 2, 2],
                                    color: '#2068F9',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#35434C",
                                            fontSize: 12
                                        },
                                    },
                                },
                                data: this.storeData.regionX,
                            },
                        ],
                    };

                    this.storeChart.setOption(options);

                    let H = 0
                    if (this.checkedStore.id == 0) {
                        H = 200
                    } else {
                        H = 650
                    }
                    //将该echarts用之前配置好的option的配置项进行渲染
                    var autoHeight = options.xAxis.length * 60 + H
                    //获取option配置项中数据源的长度*每个柱状你想设定的高度+150的预留高度
                    this.storeChart.getDom().style.height = autoHeight + "px"
                    //echarts有个getDom（）的方法可以设置获取 ECharts 实例容器的 dom 节点，给节点分别设置高度
                    this.storeChart.getDom().childNodes[0].style.height = autoHeight + "px"
                    // this.storeChart.getDom().childNodes[0].childNodes[0].setAttribute("height", autoHeight)
                    this.storeChart.getDom().childNodes[0].childNodes[0].style.height = autoHeight + "px"
                    //根据窗口的大小变动图表
                    this.storeChart.resize()

                    // 跳转
                    this.storeChart.on('click', params => { // 柱形图点击事件
                        let data = {
                            id: this.checkedRegion.id,
                            storeId: params.data.id
                        }
                        saveRegionStore(data).then(() => {
                            this.$router.replace({
                                path: 'customerChurn',
                            })
                        })
                    })

                });

            },
            // 区域分布数据
            getRegionData() {
                const beginDate = getFormatTime(this.regionBeginMonth, this.pickerType)
                const endDate = getFormatTime(this.regionEndMonth, this.pickerType)
                return request({
                    url: `/index/bulletin/customers/loss/region?id=${this.checkedRegion.id}&type=${this.regionType.id}&dateType=${this.regionDateType}&beginMonth=${beginDate}&endMonth=${endDate}`,
                    method: "get",
                })
                    .then((res) => {
                        this.regionData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 门店分布数据
            getStoreData() {
                if (!this.changeId) {
                    this.changeId = this.checkedRegion.id
                }
                const beginDate = getFormatTime(this.storeBeginMonth, this.pickerType)
                const endDate = getFormatTime(this.storeEndMonth, this.pickerType)
                return request({
                    url: `/index/bulletin/customers/loss/store?id=${this.changeId}&type=${this.storeType.id}&dateType=${this.storeDateType}&beginMonth=${beginDate}&endMonth=${endDate}`,
                    method: "get",
                })
                    .then((res) => {
                        this.storeData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            onRefresh() {
                this.refreshing = false;
                this.onLoad();
            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        this.reload();
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.showRegionStorePopup = false
                this.checkedStore = data
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    if (data.id != 0 && data.id != -1) {
                        this.$router.replace({
                            name: "customerChurn"
                        });
                    }
                })
            },
            // 筛选类型
            openRegionSelectPopup() {
                this.showRegionSelectPopup = true
            },
            openStoreSelectPopup() {
                this.showStoreSelectPopup = true
            },
            onRegionSelectChange(data) {
                this.regionType = data
                this.showRegionSelectPopup = false
                this.initRegionChart()
            },
            onStoreSelectChange(data) {
                this.storeType = data
                this.showStoreSelectPopup = false
                this.initStoreChart()
            },
            // 时间确定
            handleRegionDate(id, begin, end) {
                this.showRegionTimePopup = false
                this.regionDateType = id
                if (!id) {
                    this.regionBeginMonth = begin
                    this.regionEndMonth = end
                } else {
                    this.beginMonth = ''
                    this.endMonth = ''
                }
                this.initRegionChart()
            },
            handleStoreDate(id, begin, end) {
                this.showStoreTimePopup = false
                this.storeDateType = id
                if (!id) {
                    this.storeBeginMonth = begin
                    this.storeEndMonth = end
                } else {
                    this.storeBeginMonth = ''
                    this.storeEndMonth = ''
                }
                this.initStoreChart()
            },
            // 时间弹窗
            selectRegionTimePopup() {
                this.showRegionTimePopup = true
            },
            selectStoreTimePopup() {
                this.showStoreTimePopup = true
            },
        },
    };
</script>

<style scoped lang="less">
    .van-pull-refresh {
        min-height: 100%;
    }

    .storageassets-module {
        height: 100%;
        overflow-y: auto;
    }

    .store-box {
        padding: 30px 30px;
        padding-bottom: 0;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }

    .title-box {
        margin-top: 40px;
        padding: 0 30px;

        .icon {
            width: 40px;
            height: 40px;
            margin-right: 20px;
        }

        .total-amount {
            .txt {
                font-size: 26px;
                color: #a0acb5;
            }

            .select-arrow {
                transform: rotate(90deg);
                font-size: 24px;
                margin-left: 20px;
            }
        }
    }

    .price-box {
        padding: 27px 30px 0 30px;

        .unit {
            margin-left: 8px;
            margin-right: 30px;
        }
    }

    .unit {
        margin-right: 34px;
        margin-top: 20px;
        font-size: 26px;
        color: #66757f;
        text-align: right;
    }

    #regionchart {
        width: 100%;
        height: 449px;
    }

    #storechart {
        width: 100%;
        height: 449px;
    }

    .cut-line {
        width: 100%;
        height: 20px;
        background: #f8f8fa;
    }

    .empty-box {
        height: 416px;
        background-color: #fff;
        padding-top: 50px;

        .empty-icon {
            width: 210px;
            height: 210px;
        }

        .empty-txt {
            font-size: 28px;
            color: #a0acb5;
        }
    }

    .add-up-box {
        padding: 30px 150px 50px 150px;

        >.tit {
            width: 321px;
            font-size: 24px;
            color: #a0acb5;

            .num {
                font-weight: 700;
                color: #35434c;
            }
        }

        >.tit:nth-child(1) {
            margin-right: 58px;
        }
    }

    .date-box {
        padding: 50px 30px 0 30px;

        .date {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-size: 30px;
            color: #35434c;
        }

        .arrow-l {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-right: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-right: 30px;
        }

        .arrow-r {
            width: 0;
            height: 0;
            border-top: 10px solid transparent;
            border-left: 10px solid #35434c;
            border-bottom: 10px solid transparent;
            margin-left: 30px;
        }
    }

    .select-box {
        margin-top: 50px;
        margin-left: 30px;
        margin-right: 30px;

        .select-tit {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 10px;
        }

        .rate-box {
            color: #66757f;
        }
    }

    .total-amount {
        margin-left: 20px;
        margin-top: 44px;

        .txt {
            font-size: 28px;
            color: #35434c;
        }

        .select-arrow {
            transform: rotate(90deg);
            font-size: 24px;
            margin-left: 20px;
        }
    }
</style>
